import {ChangeEvent, useCallback, useState} from "react";

export const useFormInput = (initialValue: string = ""): [string, (event: ChangeEvent<HTMLInputElement>) => void] => {
    const [value, setValue] = useState<string>(initialValue)
    const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value)
    }, [])

    return [value, handleChange]
}

export const useFormCheckbox = (initialValue: boolean = false): [boolean, (event: ChangeEvent<HTMLInputElement>) => void] => {
    const [value, setValue] = useState<boolean>(initialValue)
    const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.checked)
    }, [])

    return [value, handleChange]
}
